import accordion from './accordion';

export default accordion;
